<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户维护</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
            style="width: 300px"
            @clear="getguestList"
            @change="getguestList"
          >
          </el-input>
            <el-radio-group v-model="queryInfo.CI_canshu03" @change="getguestList" style="margin-left:10px;">
          <el-radio  :label="100">全部</el-radio>
          <el-radio   :label="0">普通会员</el-radio>
          <el-radio   :label="1">VIP会员</el-radio>
         <el-radio   :label="2">高级会员</el-radio>
           </el-radio-group>
           <el-button slot="append" icon="el-icon-search" @click="getguestList"></el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="get_guest_edit" v-if="this.pageType === '1'"
            >添加客户</el-button
          >
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button type="primary" @click="handleExport()">导出当前页电子表格</el-button>
          <el-button type="primary" @click="handleExportAll()">导出所有页电子表格</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="guestList" style="width: 100%" border stripe id="report">
            <el-table-column type="expand" v-if="pageType === 2">
              <template slot-scope="scope">
                <el-table
                  :data="scope.row.shang_list"
                  stripe
                  style="background-color: #f0f9f9"
                  id="report"
                >
                  <el-table-column prop="guest_xuhao" label="所在层级" width="80"></el-table-column>
                  <el-table-column prop="guest_bianhao" label=" 编号"></el-table-column>
                  <el-table-column prop="guest_name" label=" 姓名"></el-table-column>
                  <el-table-column
                    prop="huiyuan_qiye_bianhao"
                    label="会员所属门店编号"
                  ></el-table-column>
                  <el-table-column
                    prop="huiyuan_qiye_name"
                    label="会员所属门店名称"
                  ></el-table-column>
                  <el-table-column prop="huiyuan_yu" label="储值账户"></el-table-column>
                  <!-- <el-table-column prop="guest_accout_fenhong" label="分红账户"></el-table-column>
                                    <el-table-column prop="guest_accout_jiyou" label="机油卡"></el-table-column>
                                    <el-table-column prop="guest_accout_baoyang" label="保养卡"></el-table-column>
                                    <el-table-column prop="guest_accout_xiche" label="洗车卡"></el-table-column> -->
                  <el-table-column prop="guest_mob" label="手机"></el-table-column>
                  <el-table-column prop="guest_addr" label="地址"></el-table-column>
                  <el-table-column prop="add_time" label="加入时间"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column type="expand" v-if="pageType === 3">
              <template slot-scope="scope">
                <el-table :data="scope.row.mingxi_guest" stripe style="background-color: #f0f9f9">
                  <el-table-column prop="mingxi_money" label="明细金额"></el-table-column>
                  <el-table-column prop="add_time" label="时间"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="uid" label="序号" width="80"></el-table-column>
            <el-table-column prop="guest_bianhao" label=" 编号" v-if="false"></el-table-column>
            <el-table-column prop="guest_name" label=" 姓名"></el-table-column>
            <el-table-column prop="huiyuan_qiye_bianhao" label="会员所属门店编号"></el-table-column>
            <el-table-column prop="huiyuan_qiye_name" label="会员所属门店名称"></el-table-column>
            <el-table-column label=" 客户类型">
              <template slot-scope="scope3">
                {{ scope3.row.guest_huiyuan_level === 0 ? '普通用户' : '' }}
                {{ scope3.row.guest_huiyuan_level === 1 ? 'VIP会员' : '' }}
                {{ scope3.row.guest_huiyuan_level === 2 ? '高级会员' : '' }}
              </template>
            </el-table-column>
            <el-table-column label=" 门店vip类型">
              <template slot-scope="scope3">
                {{ scope3.row.guest_level === 0 ? '普通客户' : '' }}
                {{ scope3.row.guest_level === 1 ? '门店VIP会员' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="huiyuan_yu" label="储值账户"></el-table-column>
            <el-table-column prop="guest_accout_fenhong" label="分红账户"></el-table-column>
            <el-table-column prop="guest_accout_jiyou" label="机油卡"></el-table-column>
            <el-table-column prop="guest_accout_baoyang" label="保养卡"></el-table-column>
            <el-table-column prop="guest_accout_xiche" label="洗车卡"></el-table-column>

            <el-table-column prop="guest_mob" label="手机"></el-table-column>
            <el-table-column prop="guest_addr" label="地址"></el-table-column>
            <el-table-column prop="add_time" label="加入时间"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="showEditDialog(scope.row.uid)"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                  v-if="user_type === '2'"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="预约登记"
                  placement="top"
                  :enterable="false"
                  style="display: none"
                >
                  <el-button
                    type="success"
                    icon="el-icon-orange"
                    @click="showYuyueDialog(scope.row.uid)"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            :data="guestListAll"
            style="width: 100%; display: none"
            border
            stripe
            id="reportAll"
          >
            <el-table-column prop="uid" label="序号" width="80"></el-table-column>
            <el-table-column prop="guest_bianhao" label=" 编号" v-if="false"></el-table-column>
            <el-table-column prop="guest_name" label=" 姓名"></el-table-column>
            <el-table-column label=" 客户类型">
              <template slot-scope="scope3">
                {{ scope3.row.guest_huiyuan_level === 0 ? '普通用户' : '' }}
                {{ scope3.row.guest_huiyuan_level === 1 ? 'VIP会员' : '' }}
                {{ scope3.row.guest_huiyuan_level === 2 ? '高级会员' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="huiyuan_yu" label="储值账户"></el-table-column>
            <el-table-column prop="guest_accout_fenhong" label="分红账户"></el-table-column>
            <el-table-column prop="guest_accout_jiyou" label="机油卡"></el-table-column>
            <el-table-column prop="guest_accout_baoyang" label="保养卡"></el-table-column>
            <el-table-column prop="guest_accout_xiche" label="洗车卡"></el-table-column>
            <el-table-column prop="guest_mob" label="手机"></el-table-column>
            <el-table-column prop="guest_addr" label="地址"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>

      <!-- 添加客户部分 -->
      <!-- 管理调用 -->
      <el-dialog
        title="添加客户"
        :visible.sync="addDialogVisible"
        width="50%"
        @close="addDoalogClosed"
      >
        <guestAdd
          ref="guestAdd"
          @getGuestNewUid="getGuestNewUid"
          @closeGuest="closeGuest"
          :diaoyongType="1"
          :key="datekey"
          :editUid="editUid"
          :caozuoType="caozuoType"
        >
        </guestAdd>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import exportExcel from './config/exportExcel'
import guestAdd from './module/guest_add.vue'
import { checkMobileTest, checkSfzId } from './config/validator'
import { ref } from 'vue'
export default {
  props: ['user_type', 'pageType', 'mingxi_type', 'mingxiMain_type'],
  // user_type 登录用户类型 1门店  2管理员
  // pageType  1 客户信息浏览 2 团队查看    mingxi_type 明细类型     mingxiMain_type  明细类型所属的主类型
  /*
1 客户消费明细
2 客户现金账户明细
3 客户保养卡明细
4 客户机油卡明细
5 客户洗车卡明细
6 客户分红账户明细
7 客户退款明细
8 客户冻结明细

002  门店
11门店应缴款明细
12门店入库账户明细
13门店销售账户
*/
  components: {
    guestAdd: guestAdd
  },
  data() {
    return {
      datekey: Date.now(),
     guest_huiyuan_level: 100, // 按等级筛选客户
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list_more',
        C_table_name: 'guest_list_more',
        query: '',
        pageNum: 1,
        pageSize: 10,
        CI_canshu01: this.mingxiMain_type,
        CI_canshu02: this.mingxi_type,
        CI_canshu03: this.guest_huiyuan_level
      },
      queryInfoAll: {
        C_type: 'get_list_more',
        C_table_name: 'guest_list_more',
        query: '',
        pageNum: 1,
        pageSize: 100000,
        CI_canshu01: this.mingxiMain_type,
        CI_canshu02: this.mingxi_type
      },
      huifang_isDisable: false,
      add_isDisable: false,
      guestList: [],
      guestListAll: [],
      xiaoquList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      huifangDialogVisible: false,

      // 用于设置回访页面滑块值
      //  添加表单数据项
      huifangForm: {
        C_type: 'huifang_add',
        huifang_guest_uid: 0,
        huifang_title: '',
        hufiang_memo: '',
        huifang_genjin: 1,
        huifang_switch: true
      },
      caozuoType: 0, // 操作类型 1 是添加 2是删除
      editUid: 0, // 修改uid
      addForm: {
        C_type: 'guest_add',
        uid: 0,
        guest_bianhao: '',
        guest_name: '',
        guest_mob: '',
        guest_addr: '',
        guest_sfz_bianhao: '',
        guest_level: '',
        guest_memo: '',
        username: '',
        password: '123456',
        guest_yixiang: '',
        guest_laiyuan: '',
        guest_price_want: 0
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        guest_name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        ],

        guest_mob: [
          {
            validator: checkMobileTest.bind(this.addForm && this.addForm.guest_mob)
          }
        ],
        guest_sfz_bianhao: [
          {
            validator: checkSfzId.bind(this.addForm && this.addForm.guest_sfz_bianhao)
          }
        ]
      },

      editFormRules: {}
    }
  },
  created() {
    this.getguestList()
  },

  methods: {
    handleExport() {
      exportExcel('report', '当前页客户信息.xlsx')
    },
    handleExportAll() {
      exportExcel('reportAll', '所有客户信息.xlsx')
    },
    closeGuest(data) {
      this.addDialogVisible = false
    },
    getGuestNewUid(data) {
      // 客户添加返回的结果，可以读取客户信息，在这里，只需要关闭窗口就好
      this.getguestList()
      this.addDialogVisible = false
      console.log(100, data)
    },
    async get_guest_edit() {
      this.addDialogVisible = true // 要先打开才能调用
      // 通过更改组件的key 值，强制组件进行实时更新，每次出发create 函数
      this.datekey = Date.now()
      this.editUid = 0
      this.caozuoType = 1
      //
    },
    async getguestList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      // console.log(JSON.parse(res.data)[0].dataList)
      this.guestList = JSON.parse(res.data)[0].dataList
      console.log(this.guestList)
      if (!this.guestList) return
      this.guestList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1
      })
      this.total = JSON.parse(res.data)[0].total

      const { data: res02 } = await this.$http.get('get_api', {
        params: this.queryInfoAll
      })
      // console.log(JSON.parse(res.data)[0].dataList)
      this.guestListAll = JSON.parse(res02.data)[0].dataList
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getguestList()
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getguestList()
    },
    showEditDialog(uid) {
      // this.guestInfo(uid);
      this.editUid = uid // 写uid
      this.caozuoType = 2

      this.datekey = Date.now() // 强制更新
      this.addDialogVisible = true
    },
    addDoalogClosed() {
      this.$refs.guestAdd.resetForm()
    },
    huifangDoalogClosed() {
      this.$refs.huifangFormRef.resetFields()
    },
    showHuifangDialog(uid) {
      this.huifangDialogVisible = true
      this.guestInfo(uid)
    },
    async Info(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'guest_info', uid: uid, C_type: 'get_info' }
      })
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败')
      }
      this.editForm = JSON.parse(res.data)[0].data[0]
      this.huifangForm.huifang_guest_uid = JSON.parse(res.data)[0].data[0].uid
    },

    async deleteForm(guestUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'guest_del',
        C_data1: guestUid
      })
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message.success('删除成功')
      this.getguestList()
    },

    // 设置白名单
    async baiMingdan(guestUid, baiMingdanFlag) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      var flag = 0
      if (baiMingdanFlag) flag = 0
      else flag = 1
      const comfirmResult = await this.$confirm('确定要设置为白名单吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消')

      const { data: res } = await this.$http.post('api', {
        C_type: 'guest_baiMingdan',
        guestUid: guestUid,
        baiMingdanFlag: flag
      })
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('设置失败')
        return
      }
      this.$message.success('设置成功')
      this.getguestList()
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}
</style>
